const ENVIRONMENTS = {
  production: {
    BASE_URL: "https://onboarding.acrossassist.com/",
    ATP_API_BASE_URL: "https://onboardingapi.acrossassist.com/",
  },
  staging: {
    BASE_URL: "https://test4.acrossassist.in",
    ATP_API_BASE_URL: "https://onboarding.acrossassist.in/",
  },
  development: {
    BASE_URL: "http://localhost:3000",
    ATP_API_BASE_URL: "https://onboarding.acrossassist.in/",
  },
};

const getEnvironment = () => {
  const baseUrl = window.location.origin;
  console.log("URL :", baseUrl, ENVIRONMENTS.production.BASE_URL);
  if (baseUrl === ENVIRONMENTS.production.BASE_URL) {
    console.log("PRODUCTION ENVIRONMENT");
    return "production";
  } else if (baseUrl === ENVIRONMENTS.staging.BASE_URL) {
    console.log("STAGING ENVIRONMENT");
    return "staging";
  } else if (baseUrl === ENVIRONMENTS.development.BASE_URL) {
    console.log("DEVELOPMENT ENVIRONMENT");
    return "development";
  } else {
    console.log("BASE URL not matching with any environment", baseUrl);
    return "development";
  }
};

const CURRENT_ENV = getEnvironment();

export const URL_CONFIG = {
  ...ENVIRONMENTS[CURRENT_ENV],
};
